import type { StaticLayerPayload } from "@config";
import { AttachmentLibrary, AttachmentPdf } from "@library-elements/attachment";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: AttachmentLibrary,
  pdf: AttachmentPdf,
};

export const Attachment = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
